import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "https://indurstudycircle.com";

/** Keeps canonical and og:url pointed at the current page. */
export default function CanonicalUrl() {
  const { pathname } = useLocation();
  useEffect(() => {
    const url = SITE + (pathname === "/" ? "/" : pathname.replace(/\/+$/, ""));
    let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = url;
    document.querySelector('meta[property="og:url"]')?.setAttribute("content", url);
  }, [pathname]);
  return null;
}
